export default __webpack_public_path__ + "static/media/ted.e81584a8.png";